export const EM_DASH = '\u2014';

export const formatDaysValue = (days: number | null | undefined): string => {
  if (days == null || isNaN(days)) return EM_DASH;
  return `${days.toFixed(1)} days`;
};

export const formatPercentage = (value: number | null | undefined, decimals = 1): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return `${value.toFixed(decimals)}%`;
};

export const formatDecimal = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return value.toFixed(1);
};

export const formatWholeNumber = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return String(value);
};

// At-a-glance duration, coarse on purpose. Drops any leading zero unit and rolls over to days past
// 24 hours, so a short span reads "45m" (not "0h 45m") and a long one "3d 4h" (not "76h") — matching
// the inbound referral list's Time Elapsed banding (OLIO-3372). Bands: "<1m" under a minute; "45m"
// under an hour; "2h" / "2h 15m" under a day; "3d" / "3d 4h" beyond.
// Floors to whole minutes (like the list's `elapsed`), so anything genuinely under a minute — 30s
// included — reads "<1m" rather than rounding up to "1m".
export const formatResponseTime = (seconds: number | null | undefined): string => {
  if (seconds == null || isNaN(seconds)) return EM_DASH;
  const totalMinutes = Math.floor(seconds / 60);
  if (totalMinutes < 1) return '<1m';
  if (totalMinutes < 60) return `${totalMinutes}m`;
  if (totalMinutes < 24 * 60) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
  }
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  return hours === 0 ? `${days}d` : `${days}d ${hours}h`;
};
